var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notification_svg__a)",
    stroke: "#1A1E2C",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.034 15.053v-4.956c0-3.047-1.607-5.59-4.423-6.264V3.16c0-.822-.659-1.486-1.475-1.486-.816 0-1.474.664-1.474 1.486v.674c-2.816.674-4.423 3.217-4.423 6.264v4.956l-1.966 1.982v.992H20v-.992l-1.966-1.982ZM12.136 21a1.974 1.974 0 0 0 1.966-1.982h-3.931c0 1.095.88 1.982 1.965 1.982Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notification_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNotification;